import { useGuttagekonto } from '@/domain/mitarbeiter/features/guttagekonto/hooks/useGuttagekonto';
import { Card, CardContent, DataDisplayProminent, Heading } from '@e2n/ui/v2';
import {
  faArrowRightArrowLeft,
  faGaugeCirclePlus,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import dayjs from 'dayjs';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { GuttagekontoUebertragCard } from '@/domain/mitarbeiter/features/guttagekonto/components/GuttagekontoUebertragCard';

export function GuttagekontoCards() {
  const { t } = useTranslation();
  const { id } = useParams();
  const currentYear = dayjs().year();
  const { guttagekonto } = useGuttagekonto([id], currentYear);

  return (
    <>
      <Heading size="md">{t('domain.mitarbeiter.guttagekonto.title')}</Heading>
      <div className="flex flex-col md:flex-row gap-4">
        <Card className="w-full h-20" variant="default">
          <CardContent>
            <div className="flex row gap-4">
              <DataDisplayProminent
                size="lg"
                label={t('domain.mitarbeiter.guttagekonto.kontostand')}
                value1={guttagekonto.istStand}
                unit1="Tage"
                showLeadingIcon
                leadingIcon={<FontAwesomeIcon icon={faGaugeCirclePlus} />}
              />
            </div>
          </CardContent>
        </Card>
        <Card className="w-full h-20" variant="default">
          <CardContent>
            <div className="flex row gap-4 justify-between">
              <DataDisplayProminent
                size="lg"
                label={t('domain.mitarbeiter.guttagekonto.uebertrag')}
                value1={guttagekonto.uebertragAusVorjahr}
                unit1="Tage"
                showLeadingIcon
                leadingIcon={<FontAwesomeIcon icon={faArrowRightArrowLeft} />}
              />
              <GuttagekontoUebertragCard />
            </div>
          </CardContent>
        </Card>
      </div>
    </>
  );
}
